import { jsx as r } from "react/jsx-runtime";
import "react";
var e = (l) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...l,
  children: /* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M22.065 4.11 10.471 16.446s-1.855 1.555.19 3.456l10.936 11.456c.462.484 1.115.739 1.752.61.427-.087.854-.341 1.09-.952.588-1.525-.353-2.44-.353-2.44l-9.921-10.517 9.921-10.593s1.102-1.253.353-2.473c-.75-1.22-2.23-1.034-2.374-.881Z"
  })
});
export {
  e as default
};
